import { cubicEaseOut } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { baseGrid, siteWide } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.div `
  --fgColor: ${brand.grey.grey6};
  --bgColor: ${brand.white};

  position: fixed;
  top: var(--headerHeight);
  left: 0;
  display: flex;
  flex-direction: column;
  background: var(--bgColor);
  color: var(--fgColor);
  height: calc(100% - var(--headerHeight));
  opacity: 0;
  overflow-y: auto;
  padding: 36px 0;
  pointer-events: none;
  transition: opacity 0.15s ${cubicEaseOut};
  width: 100%;

  [data-d-active='true'] & {
    opacity: 1;
    pointer-events: all;
  }

  @media ${from(Device.DesktopLarge)} {
    padding: 72px 0;
  }
`;
const Inner = styled.div `
  ${siteWide};
  ${baseGrid};
  grid-template-rows: auto 1fr;
  height: 100%;
`;
const Current = styled.span `
  display: block;
  color: ${brand.blue.base};
  ${fonts.helvetica.bold};
  font-size: 20px;
  grid-column: 1 / span 4;
  grid-row: 1;
  line-height: 1em;
  margin: 0 0 24px;

  @media ${from(Device.DesktopLarge)} {
    font-size: 24px;
    grid-column: 2 / span 3;
    margin: 0 0 48px;
  }
`;
const Column = styled.div `
  border-right: 1px solid ${brand.grey.grey3};
  padding-right: 32px;
`;
const Column1 = styled(Column) `
  grid-column: 1 / span 4;
  grid-row: 2;

  @media ${from(Device.DesktopLarge)} {
    grid-column: 2 / span 3;
  }
`;
const Column2 = styled(Column) `
  grid-column: 5 / span 4;
  grid-row: 2;

  @media ${from(Device.DesktopLarge)} {
    grid-column: 5 / span 3;
  }
`;
const Column3 = styled(Column) `
  border-right: 0;
  grid-column: 9 / span 4;
  grid-row: 2;

  @media ${from(Device.DesktopLarge)} {
    grid-column: 8 / span 3;
  }
`;
const ArticleColumn = styled(Column) `
  border-right: 0;
  grid-column: -5 / span 4;
  grid-row: 1 / span 2;
  justify-self: flex-end;
  max-width: 417px;
  padding-right: 0;
`;
const List = styled.ul ``;
const Item = styled.li `
  display: block;
`;
const Link = styled.a `
  display: flex;
  align-items: center;
  color: ${brand.grey.grey5};
  ${fonts.helvetica.bold};
  font-size: 16px;
  height: 56px;
  line-height: 1em;
  padding: 0;
  text-decoration: none;

  @media ${from(Device.DesktopLarge)} {
    font-size: 20px;
    height: 72px;
  }

  &:focus {
    outline: none;
  }
`;
const Text = styled.span `
  overflow: hidden;
  overflow: clip;
  padding: 0 0 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;

  ${Link}[data-active="true"] &,
  ${Link}:focus &,
  ${Link}:hover & {
    color: ${brand.blue.base};
    text-decoration: underline;
    text-underline-position: under;
  }
`;
const DesktopDropdownStyles = {
    ArticleColumn,
    Column1,
    Column2,
    Column3,
    Container,
    Current,
    Inner,
    Item,
    Link,
    List,
    Text,
};
export default DesktopDropdownStyles;
